export default "<p>products works!</p>\n"